export const USERS_FETCH_DATA_INIT = "USERS_FETCH_DATA_INIT";
export const USERS_FETCH_DATA_SUCCESS = "USERS_FETCH_DATA_SUCCESS";
export const USERS_FETCH_DATA_FAIL = "USERS_FETCH_DATA_FAIL";
//plopImport
export const DELETE_USER_INIT = "DELETE_USER_INIT";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_ERROR = "DELETE_USER_ERROR";
